
import { OrganizationsHeader } from "./OrganizationsHeader";
import { OrganizationsFilter } from "./OrganizationsFilter";
import { OrganizationsTable } from "./OrganizationsTable";
import { CreateOrganizationDialog } from "./CreateOrganizationDialog";
import { EditOrganizationDialog } from "./EditOrganizationDialog";
import { DeleteOrganizationDialog } from "./DeleteOrganizationDialog";
import { useOrganizationManagement, OrganizationData } from "@/hooks/useOrganizationManagement";
import { useState } from "react";

export function Organizations() {
  const {
    organizations,
    loading,
    searchTerm,
    setSearchTerm,
    sortColumn,
    sortDirection,
    onSort,
    createOrganization,
    updateOrganization,
    deleteOrganization,
  } = useOrganizationManagement();

  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedOrganization, setSelectedOrganization] = useState<OrganizationData | null>(null);

  const handleEdit = (organization: OrganizationData) => {
    setSelectedOrganization(organization);
    setEditDialogOpen(true);
  };

  const handleDelete = (organization: OrganizationData) => {
    setSelectedOrganization(organization);
    setDeleteDialogOpen(true);
  };

  const handleCreateSuccess = async (name: string) => {
    const success = await createOrganization(name);
    if (success) {
      setCreateDialogOpen(false);
    }
    return success;
  };

  const handleEditSuccess = async (name: string) => {
    if (!selectedOrganization) return false;
    
    const success = await updateOrganization(selectedOrganization.id, name);
    if (success) {
      setEditDialogOpen(false);
      setSelectedOrganization(null);
    }
    return success;
  };

  const handleDeleteSuccess = async () => {
    if (!selectedOrganization) return false;
    
    const success = await deleteOrganization(selectedOrganization.id);
    if (success) {
      setDeleteDialogOpen(false);
      setSelectedOrganization(null);
    }
    return success;
  };

  return (
    <div className="space-y-6">
      <OrganizationsHeader onCreateClick={() => setCreateDialogOpen(true)} />
      
      <OrganizationsFilter 
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
      />
      
      <OrganizationsTable
        organizations={organizations}
        loading={loading}
        sortColumn={sortColumn}
        sortDirection={sortDirection}
        onSort={onSort}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      <CreateOrganizationDialog
        open={createDialogOpen}
        onOpenChange={setCreateDialogOpen}
        onSuccess={handleCreateSuccess}
      />

      {selectedOrganization && (
        <>
          <EditOrganizationDialog
            open={editDialogOpen}
            onOpenChange={setEditDialogOpen}
            organization={selectedOrganization}
            onSuccess={handleEditSuccess}
          />

          <DeleteOrganizationDialog
            open={deleteDialogOpen}
            onOpenChange={setDeleteDialogOpen}
            organization={selectedOrganization}
            onSuccess={handleDeleteSuccess}
          />
        </>
      )}
    </div>
  );
}
